import deletedMemberModal from './deletedMemberModal';

export default deletedMemberModal;
